<div class=" d-none d-sm-block">
<h2 style="text-align: center;">About Us</h2>
<br>  
  <div class="table-container" style="padding-left: 25%;">
    <h3 style="align-items: center; text-align: center;">MANDATORY PUBLIC DISCLOSURE</h3>  
    <h5 style="text-align: left;">GENERAL INFORMATION</h5>
    <table class="table table-bordered align-middle" style="align-items: center; text-align: center; justify-items: center;">
      <thead>
        <tr>
          <th style="color: white;">Sl. NO.</th>
          <th style="color: white;">PARTICULARS</th>
          <th style="color: white;">DETAILS</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td><strong>NAME OF THE SCHOOL</strong></td>
          <td><strong>SRI PARASAKTHI VIDYALAYA -CBSE, COURTALLAM.</strong></td>
        </tr>
        <tr>
          <td>2</td>
          <td><strong>AFFILIATION NO. (IF APPLICABLE)</strong></td>
          <td><strong>1930135</strong></td>
        </tr>
        <tr>
          <td>3</td>
          <td><strong>SCHOOL CODE (IF APPLICABLE)</strong></td>
          <td><strong>55086</strong></td>
        </tr>
        <tr>
          <td>4</td>
          <td><strong>COMPLETE ADDRESS WITH PIN CODE</strong></td>
          <td><strong>SRI PARASAKTHI VIDYALAYA -CBSE <br> COURTALLANATHAR ROAD,COURTALLAM. 627802</strong></td>
        </tr>
        <tr>
          <td>5</td>
          <td><strong>PRINCIPAL NAME & QUALIFICATION</strong></td>
          <td><strong>MS P.JEYALAKSHMI - M.A.,B.Ed.,</strong></td>
        </tr>
        <tr>
          <td>6</td>
          <td><strong>SCHOOL EMAIL ID</strong></td>
          <td><strong>55086@cbseshiksha.in</strong></td>
        </tr>
        <tr>
          <td>7</td>
          <td><strong>CONTACT DETAILS (LANDLINE / MOBILE)</strong></td>
          <td><strong>04633-283133, 8122983133</strong> </td>
        </tr>
      </tbody>
    </table>
  </div>
  <hr>
  <br>
  <div class="table-container" style="padding-left: 25%;">
    <h2 style="text-align: center; align-items: center;">DOCUMENTS AND INFORMATION</h2>
    <br>
       <table class="table table-bordered align-middle" style="align-items: center; text-align: center; justify-items: center;">
      <thead>
        <tr>
          <th style="color: white;">Sl. No.</th>
          <th style="color: white;">DOCUMENTS AND INFORMATION</th>
          <th style="color: white;">UPLOAD DOCUMENTS</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td><strong>COPIES OF AFFILIATION/UPGRADATION LETTER AND RECENT EXTENSION OF AFFILIATION IF ANY</strong></td>
          <td><strong><a href="../../assets/img/aboutus1.pdf" target="_blank">CLICK IMAGE</a></strong></td>
        </tr>
        <tr>
          <td>2</td>
          <td><strong>COPIES OF SOCIETIES/TRUST/ COMPANY REGISTRATION/RENEWAL CERTIFICATE, AS APPLICABLE</strong></td>
          <td><strong><a href="../../assets/img/aboutus2.pdf" target="_blank">CLICK IMAGE</a></strong></td>
        </tr>
        <tr>
          <td>3</td>
          <td><strong>COPY OFOBJECTION CERTIFICATE (NOC) ISSUED, IF APPLICABLE, BY THE STATE GOVT./UT</strong></td>
          <td><strong><a href="../../assets/img/aboutus3.pdf" target="_blank">CLICK IMAGE</a></strong></td>
        </tr>
        <tr>
          <td>4</td>
          <td><strong>COPIES OF RECOGNITION CERTIFICATE UNDER RTE ACT, 2009,AND IT'S RENEWAL IF APPLICABLE</strong></td>
          <td><strong><a href="../../assets/img/aboutus4.jpeg" target="_blank">CLICK IMAGE</a></strong> </td>
        </tr>
        <tr>
          <td>5</td>
          <td><strong>COPY OF VALID BUILDING SAFETY CERTIFICATE AS PER THE NATIONAL BUILDING CODE</strong></td>
          <td><strong><a href="../../assets/img/aboutus5.pdf" target="_blank">CLICK IMAGE</a></strong> </td>
        </tr>
        <tr>
          <td>6</td>
          <td><strong>COPY OF VALID FIRE SAFETY CERTIFICATE ISSUED BY THE COMPETENT AUTHORITY</strong></td>
          <td><strong><a href="../../assets/img/FIRE SAFETY.pdf" target="_blank">CLICK IMAGE</a></strong> </td>
        </tr>
        <tr>
          <td>7</td>
          <td><strong>COPY OF THE DEO CERTIFICATE SUBMITTED BY THE SCHOOL FOR AFFLICTION/UPGRADATION/EXTENSION OF AFFILIATION SELF CERTIFICATION BY SCHOOL</strong></td>
          <td><strong><a href="../../assets/img/docs&info.jpeg" target="_blank">CLICK IMAGE</a></strong> </td>
        </tr>
        <tr>
          <td>8</td>
          <td><strong>COPIES OF VALID DRINKING WATER, HEALTH AND SANITATION CERTIFICATES AND WATER TESTING REPORT</strong></td>
          <td><strong><a href="../../assets/img/aboutus8.pdf" target="_blank">CLICK IMAGE</a></strong> </td>
        </tr>
      </tbody>
    </table>
  </div>
  <hr>
  <br>
  <div class="table-container" style="padding-left: 25%;">
    <h2 style="text-align: center;">RESULT AND ACADEMICS</h2>
    <br>
      <table class="table table-bordered align-middle" style="align-items: center; text-align: center; justify-items: center;">
      <thead>
        <tr>
          <th style="color: white;">Sl. No.</th>
          <th style="color: white;">DOCUMENTS/INFORMATION</th>
          <th style="color: white;">DOCUMENTS</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td><strong>FEE STRUCTURE OF THE SCHOOL</strong></td>
          <td><a href="../../assets/img/fesss.jpeg"  target="_blank">CLICK HERE</a></td>
        </tr>
        <tr>
          <td>2</td>
          <td><strong>ANNUAL ACADEMIC CALANDER</strong></td>
          <td><a href="../../assets/img/annualacademic.pdf" target="_blank">CLICK HERE</a></td>
        </tr>
        <tr>
          <td>3</td>
          <td><strong>LIST OF SCHOOL MANAGEMENT COMMITTEE (SMC)</strong></td>
          <td><a href="../../assets/img/schoolcommitee.jpeg" target="_blank">CLICK HERE</a></td>
        </tr>
        <tr>
          <td>4</td>
          <td><strong>LIST OF PARENTS TEACHERS ASSOCIATION (PTA) MEMBERS</strong></td>
          <td><a href="../../assets/img/parentteachers4.jpeg" target="_blank">CLICK HERE</a></td>
        </tr>
          <!-- <tr>
          <td>5</td>
          <td><strong>STUDENT DETAILS</strong></td>
          <td><a href="../../assets/img/aboutus55.jpeg" target="_blank">CLICK HERE</a></td>
        </tr> -->
      </tbody>
    </table>
    </div>
    <hr>
  <br>
   <div class="table-container" style="padding-left: 25%;">
    <h2 style="text-align: center;">RESULT CLASS: X</h2>
      <table class="table table-bordered align-middle" style="align-items: center; text-align: center; justify-items: center;">
      <thead>
        <tr>
          <th style="color: white;">Sl. NO.</th>
          <th style="color: white;">YEAR</th>
          <th style="color: white;">NO. OF REGISTERED STUDENTS</th>
          <th style="color: white;">NO. OF STUDETNS PASSED</th>
          <th style="color: white;">PASS PERCENTAGE</th>
          <th style="color: white;">REMARKS</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>2023</td>
          <td>150</td>
          <td>129</td>
          <td>86%</td>
          <td></td>
        </tr>
        <tr>
          <td>2</td>
          <td>2024</td>
          <td>116</td>
          <td>114</td>
          <td>98.28%</td>
          <td></td>
        </tr>
        <tr>
          <td>3</td>
          <td>2025</td>
          <td>102</td>
          <td>102</td>
          <td>100%</td>
          <td></td>
        </tr>
        <tr>
          <td>4</td>
          <td>2026</td>
          <td>71</td>
          <td>71</td>
          <td>100%</td>
          <td></td>
        </tr>
      </tbody>
    </table>
    </div>
    <br>
    <hr>
  <div style="background: linear-gradient(180deg, #077A7D, #7AE2CF); color: white; padding: 30px; border-radius: 15px; text-align: center; max-width: 700px; margin: 50px auto; position: relative;">
    <h2 style="font-size: 28px; margin-bottom: 20px; font-weight: bold;">
      WANT TO KNOW MORE ABOUT OUR SCHOOL?
    </h2>
    <h5 style="margin: 16px 0;">
      Discover our curriculum, admissions, campus facilities, and more.
    </h5>
    <h5 style="margin: 16px 0;">
      <a routerLink="/contact-us" routerLinkActive="active"
        style="color: white; text-decoration: none; font-weight: 600;">
        Contact Our Admission Office&nbsp;&nbsp;
        <button style="background: white; color: #077A7D; border: none; border-radius: 50%; width: 30px; height: 30px;">
          <i class="fa fa-arrow-right"></i>
        </button>
      </a>
    </h5>
    <h5 style="margin-top: 25px;">We’re here to help you every step of the way.</h5>
  </div>
  <br>
  <div class="vision-mission-round-container">
    <div class="round-box">
      <i class="fas fa-bolt icon"></i>

      <h3>Our Vision</h3>
      <p>
        To nurture responsible, compassionate, and curious learners who are prepared to thrive in a global society.
      </p>
    </div>

    <div class="round-box">
      <i class="fa fa-bullseye icon"></i>
      <h3>Our Mission</h3>
      <p>
        To provide holistic education that blends academic excellence with character development.
      </p>
    </div>

    <div class="round-box">
      <i class="fas fa-star icon"></i>
      <h3>Our Educators</h3>
      <p>
        Our passionate faculty guide students with innovation and care, shaping their future.
      </p>
    </div>
  </div>
  <br>
  <br>
  <div class="contact-info">
    <a href="tel:04633 283133" class="contact-btn phone-btn">
      <span class="fa fa-phone"></span> Call Now
    </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <a href="mailto:sriparasakthividyala@yahoo.co.in" class="contact-btn email-btn">
      <span class="fa fa-envelope"></span> Email Us
    </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <a href="https://wa.me/8122983133" target="_blank" class="contact-btn whatsapp-btn">
      <span class="fa fa-whatsapp"></span> WhatsApp
    </a>
  </div>
  <div style="flex: 1; height: 2px; background: #ddd; margin: 0 10px; position: relative;">
    <i class="fa fa-rocket" style="position: absolute; top: -12px; left: 50%; transform: translateX(-50%); background: #fff;
   padding: 5px; color: #7AE2CF; border-radius: 50%;"></i>
  </div>

</div>






<!-- ---------------------------------MOBILE VIEW------------------------------------ -->
<div class=" d-block d-sm-none">

<h2 style="text-align: center;">About Us</h2>
<br>  
 <div>
    <h4 style="align-items: center; text-align: center;">MANDATORY PUBLIC DISCLOSURE</h4>  
    <h5 style="text-align: left;">GENERAL INFORMATION</h5>
    <table class="table table-bordered">
      <thead>
        <tr>
          <th style="color: white;">Sl. No.</th>
          <th style="color: white;">PARTICULARS</th>
          <th style="color: white;">DETAILS</th>
        </tr>
      </thead>
       <tbody>
        <tr>
          <td>1</td>
          <td><strong>NAME OF THE SCHOOL</strong></td>
          <td><strong>SRI PARASAKTHI VIDYALAYA -CBSE, COURTALLAM.</strong></td>
        </tr>
        <tr>
          <td>2</td>
          <td><strong>AFFILIATION NO. (IF APPLICABLE)</strong></td>
          <td><strong>1930135</strong></td>
        </tr>
        <tr>
          <td>3</td>
          <td><strong>SCHOOL CODE (IF APPLICABLE)</strong></td>
          <td><strong>55086</strong></td>
        </tr>
        <tr>
          <td>4</td>
          <td><strong>COMPLETE ADDRESS WITH PIN CODE</strong></td>
          <td><strong>SRI PARASAKTHI VIDYALAYA -CBSE <br> COURTALLANATHAR ROAD,COURTALLAM. 627802</strong></td>
        </tr>
        <tr>
          <td>5</td>
          <td><strong>PRINCIPAL NAME & QUALIFICATION</strong></td>
          <td><strong>MS P.JEYALAKSHMI - M.A.,B.Ed.,</strong></td>
        </tr>
        <tr>
          <td>6</td>
          <td><strong>SCHOOL EMAIL ID</strong></td>
          <td><strong>55086@cbseshiksha.in</strong></td>
        </tr>
        <tr>
          <td>7</td>
          <td><strong>CONTACT DETAILS (LANDLINE / MOBILE)</strong></td>
          <td><strong>04633-283133, 8122983133</strong> </td>
        </tr>
      </tbody>
    </table>
  </div>
  <br>
  <hr>
 <div >
    <h2 style="text-align: center; align-items: center;">DOCUMENTS AND INFORMATION</h2>
    <br>
       <table class="table table-bordered">
      <thead>
        <tr>
          <th style="color: white;">Sl. No.</th>
          <th style="color: white;">DOCUMENTS AND INFORMATION</th>
          <th style="color: white;">UPLOAD DOCUMENTS</th>
        </tr>
      </thead>
     <tbody>
        <tr>
          <td>1</td>
          <td><strong>COPIES OF AFFILIATION/UPGRADATION LETTER AND RECENT EXTENSION OF AFFILIATION IF ANY</strong></td>
          <td><strong><a href="../../assets/img/aboutus1.pdf" target="_blank">CLICK IMAGE</a></strong></td>
        </tr>
        <tr>
          <td>2</td>
          <td><strong>COPIES OF SOCIETIES/TRUST/ COMPANY REGISTRATION/RENEWAL CERTIFICATE, AS APPLICABLE</strong></td>
          <td><strong><a href="../../assets/img/aboutus2.pdf" target="_blank">CLICK IMAGE</a></strong></td>
        </tr>
        <tr>
          <td>3</td>
          <td><strong>COPY OFOBJECTION CERTIFICATE (NOC) ISSUED, IF APPLICABLE, BY THE STATE GOVT./UT</strong></td>
          <td><strong><a href="../../assets/img/aboutus3.pdf" target="_blank">CLICK IMAGE</a></strong></td>
        </tr>
        <tr>
          <td>4</td>
          <td><strong>COPIES OF RECOGNITION CERTIFICATE UNDER RTE ACT, 2009,AND IT'S RENEWAL IF APPLICABLE</strong></td>
          <td><strong><a href="../../assets/img/aboutus4.jpeg" target="_blank">CLICK IMAGE</a></strong> </td>
        </tr>
        <tr>
          <td>5</td>
          <td><strong>COPY OF VALID BUILDING SAFETY CERTIFICATE AS PER THE NATIONAL BUILDING CODE</strong></td>
          <td><strong><a href="../../assets/img/aboutus5.pdf" target="_blank">CLICK IMAGE</a></strong> </td>
        </tr>
        <tr>
          <td>6</td>
          <td><strong>COPY OF VALID FIRE SAFETY CERTIFICATE ISSUED BY THE COMPETENT AUTHORITY</strong></td>
          <td><strong><a href="../../assets/img/aboutus6.pdf" target="_blank">CLICK IMAGE</a></strong> </td>
        </tr>
        <tr>
          <td>7</td>
          <td><strong>COPY OF THE DEO CERTIFICATE SUBMITTED BY THE SCHOOL FOR AFFLICTION/UPGRADATION/EXTENSION OF AFFILIATION SELF CERTIFICATION BY SCHOOL</strong></td>
          <td><strong><a href="../../assets/img/docs&info.jpeg" target="_blank">CLICK IMAGE</a></strong> </td>
        </tr>
        <tr>
          <td>8</td>
          <td><strong>COPIES OF VALID DRINKING WATER, HEALTH AND SANITATION CERTIFICATES AND WATER TESTING REPORT</strong></td>
          <td><strong><a href="../../assets/img/aboutus8.pdf" target="_blank">CLICK IMAGE</a></strong> </td>
        </tr>
      </tbody>
    </table>
  </div>
  <br>
  <hr>
  <div>
    <h2 style="text-align: center;">RESULT AND ACADEMICS</h2>
    <br>
      <table class="table table-bordered">
      <thead>
        <tr>
          <th style="color: white;">Sl. No.</th>
          <th style="color: white;">DOCUMENTS/INFORMATION</th>
          <th style="color: white;">DOCUMENTS</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td><strong>FEE STRUCTURE OF THE SCHOOL</strong></td>
           <td><a href="../../assets/img/fesss.jpeg"  target="_blank">CLICK HERE</a></td>
        </tr>
        <tr>
          <td>2</td>
          <td><strong>ANNUAL ACADEMIC CALANDER</strong></td>
          <td><a href="../../assets/img/annualacademic.pdf" target="_blank">CLICK HERE</a></td>
        </tr>
        <tr>
          <td>3</td>
          <td><strong>LIST OF SCHOOL MANAGEMENT COMMITTEE (SMC)</strong></td>
          <td><a href="../../assets/img/feesstructure3.jpeg" target="_blank">CLICK HERE</a></td>
        </tr>
        <tr>
          <td>4</td>
          <td><strong>LIST OF PARENTS TEACHERS ASSOCIATION (PTA) MEMBERS</strong></td>
             <td><a href="../../assets/img/parentteachers4.jpeg" target="_blank">CLICK HERE</a></td>
        </tr>
          <!-- <tr>
          <td>5</td>
          <td><strong>STUDENT DETAILS</strong></td>
          <td><a href="../../assets/img/aboutus55.jpeg" target="_blank">CLICK HERE</a></td>
        </tr> -->
      </tbody>
    </table>
    </div>
      <hr>
    <br>
     <div>
      <h2 style="text-align: center;">RESULT CLASS: X</h2>
      <table class="table table-bordered">
      <thead>
        <tr>
          <th style="color: white;">Sl. NO.</th>
          <th style="color: white;">YEAR</th>
          <th style="color: white;">NO. OF REGISTERED STUDENTS</th>
          <th style="color: white;">NO. OF STUDETNS PASSED</th>
          <th style="color: white;">PASS PERCENTAGE</th>
          <th style="color: white;">REMARKS</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>2023</td>
          <td>150</td>
          <td>129</td>
          <td>86%</td>
          <td></td>
        </tr>
        <tr>
          <td>2</td>
          <td>2024</td>
          <td>116</td>
          <td>114</td>
          <td>98.28%</td>
          <td></td>
        </tr>
        <tr>
          <td>3</td>
          <td>2025</td>
          <td>102</td>
          <td>102</td>
          <td>100%</td>
          <td></td>
        </tr>
        <tr>
          <td>4</td>
          <td>2026</td>
          <td>71</td>
          <td>71</td>
          <td>100%</td>
          <td></td>
        </tr>
      </tbody>
    </table>
    </div>
    <br>
    <hr>
  <div
    style="background: linear-gradient(180deg, #077A7D, #7AE2CF); color: white; padding: 30px; border-radius: 15px; text-align: center; max-width: 700px; margin: 50px auto; position: relative;">
    <h2 style="font-size: 28px; margin-bottom: 20px; font-weight: bold;">
      WANT TO KNOW MORE ABOUT OUR SCHOOL?
    </h2>

    <h5 style="margin: 16px 0;">
      Discover our curriculum, admissions, campus facilities, and more.
    </h5>

    <h5 style="margin: 16px 0;">
      <a routerLink="/contact-us" routerLinkActive="active"
        style="color: white; text-decoration: none; font-weight: 600;">
        Contact Our Admission Office&nbsp;&nbsp;
        <button style="background: white; color: #077A7D; border: none; border-radius: 50%; width: 30px; height: 30px;">
          <i class="fa fa-arrow-right"></i>
        </button>
      </a>
    </h5>

    <h5 style="margin-top: 25px;">We’re here to help you every step of the way.</h5>
  </div>


  <div class="vision-mission-round-container">
    <div class="round-box">
      <i class="fa fa-lightbulb icon"></i>
      <h3>Our Vision</h3>
      <p>
        To nurture responsible, compassionate, and curious learners who are prepared to thrive in a global society.
      </p>
    </div>

    <div class="round-box">
      <i class="fa fa-bullseye icon"></i>
      <h3>Our Mission</h3>
      <p>
        To provide holistic education that blends academic excellence with character development.
      </p>
    </div>

    <div class="round-box">
      <i class="fa fa-chalkboard-teacher icon"></i>
      <h3>Our Educators</h3>
      <p>
        Our passionate faculty guide students with innovation and care, shaping their future.
      </p>
    </div>
  </div>

  <br>
  <br>
  <br>
  <div class="contact-info">
    <a href="tel:04633 283133" class="contact-btn phone-btn">
      <span class="fa fa-phone"></span> Call Now
    </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <a href="mailto:sriparasakthividyala@yahoo.co.in" class="contact-btn email-btn">
      <span class="fa fa-envelope"></span> Email Us
    </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <a href="https://wa.me/8122983133" target="_blank" class="contact-btn whatsapp-btn">
      <span class="fa fa-whatsapp"></span> WhatsApp
    </a>
  </div>
  <div style="flex: 1; height: 2px; background: #ddd; margin: 0 10px; position: relative;">
    <i class="fa fa-rocket" style="position: absolute; top: -12px; left: 50%; transform: translateX(-50%); background: #fff;
   padding: 5px; color: #7AE2CF; border-radius: 50%;"></i>
  </div>


</div>